export type Employees = 'BELOW_1500' | 'BELOW_3000' | 'BELOW_5000' | 'BELOW_10000' | 'ABOVE_10000';

export const EmployeesLabels: { [x in Employees]: string } = {
  BELOW_1500: '職員数 1,500人未満',
  BELOW_3000: '職員数 1,500～2,999人',
  BELOW_5000: '職員数 3,000～4,999人',
  BELOW_10000: '職員数 5,000～9,999人',
  ABOVE_10000: '職員数 10,000人以上',
};

export const EmployeesKeys: { [x in Employees]: x } = {
  BELOW_1500: 'BELOW_1500',
  BELOW_3000: 'BELOW_3000',
  BELOW_5000: 'BELOW_5000',
  BELOW_10000: 'BELOW_10000',
  ABOVE_10000: 'ABOVE_10000',
};

export const EmployeesOrder: Employees[] = ['BELOW_1500', 'BELOW_3000', 'BELOW_5000', 'BELOW_10000', 'ABOVE_10000'];
